(() => {
  const buildCategoryNavigation = (scope = document) => {
    scope.querySelectorAll('[data-k9-faq-nav]').forEach((navigation) => {
      const page = navigation.closest('.k9-faq-page');
      if (!page) return;

      const arrowUrl = navigation.dataset.arrowUrl;
      const fragment = document.createDocumentFragment();

      page.querySelectorAll('.k9-faq-page__category').forEach((category) => {
        const heading = category.querySelector(':scope > h2');
        if (!heading || !category.id) return;

        const link = document.createElement('a');
        link.href = `#${category.id}`;

        const label = document.createElement('span');
        const headingLines = heading.innerText.trim().split(/\s*\n\s*/);
        headingLines.forEach((line, index) => {
          if (index > 0) label.append(document.createElement('br'));
          label.append(document.createTextNode(line));
        });
        link.append(label);

        const arrow = document.createElement('img');
        arrow.src = arrowUrl;
        arrow.width = 16;
        arrow.height = 16;
        arrow.alt = '';
        link.append(arrow);

        fragment.append(link);
      });

      navigation.replaceChildren(fragment);
    });
  };

  const bindAccordions = (scope = document) => {
    scope.querySelectorAll('[data-k9-faq-item]').forEach((item) => {
      if (item.dataset.k9FaqBound === 'true') return;

      const button = item.querySelector('.k9-faq-page__question');
      const panel = item.querySelector('.k9-faq-page__answer-panel');
      if (!button || !panel) return;

      item.addEventListener('click', (event) => {
        if (event.target.closest('a')) return;

        const shouldOpen = !item.classList.contains('is-open');
        const startHeight = panel.hidden ? 0 : panel.getBoundingClientRect().height;

        panel.getAnimations().forEach((animation) => animation.cancel());
        panel.hidden = false;

        const endHeight = shouldOpen ? panel.scrollHeight : 0;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const animation = panel.animate(
          [
            { height: `${startHeight}px` },
            { height: `${endHeight}px` },
          ],
          {
            duration: reduceMotion ? 0 : 400,
            easing: 'ease',
            fill: 'forwards',
          }
        );

        item.classList.toggle('is-open', shouldOpen);
        button.setAttribute('aria-expanded', String(shouldOpen));
        panel.setAttribute('aria-hidden', String(!shouldOpen));

        animation.addEventListener('finish', () => {
          panel.hidden = !shouldOpen;
          animation.cancel();
        }, { once: true });
      });

      item.dataset.k9FaqBound = 'true';
    });
  };

  const initializeFaq = (scope = document) => {
    buildCategoryNavigation(scope);
    bindAccordions(scope);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeFaq());
  } else {
    initializeFaq();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeFaq(event.target);
  });
})();
